import React from 'react';
import Select from 'react-select';
import styles from './CustomSelect.module.css';

const CustomSelect = ({ 
  options, 
  value, 
  onChange, 
  placeholder = "Select...", 
  isSearchable = true,
  isDisabled = false,
  isLoading = false,
  isClearable = false,
  isMulti = false,
  name,
  required = false,
  backgroundColor = '#f8fafc',
  onMenuScrollToBottom,
  formatOptionLabel
}) => {
  
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: backgroundColor,
      borderColor: state.isFocused ? '#f97316' : '#e2e8f0',
      borderRadius: '12px',
      padding: '6px 4px',
      boxShadow: state.isFocused ? '0 0 0 4px rgba(249, 115, 22, 0.1)' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? '#f97316' : '#cbd5e1',
      },
      fontSize: '15px',
      fontWeight: '500',
      minHeight: '48px',
      transition: 'all 0.2s ease',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#f97316' 
        : state.isFocused 
        ? '#fff7ed' 
        : 'white',
      color: state.isSelected ? 'white' : '#1e293b',
      '&:active': {
        backgroundColor: '#f97316',
        color: 'white',
      },
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '16px',
      padding: '8px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      border: '1px solid #f1f5f9',
      zIndex: 9999,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#94a3b8',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1e293b',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#f97316',
      '&:hover': {
        color: '#ea580c',
      }
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#fff7ed',
      borderRadius: '8px',
      border: '1px solid #fed7aa',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#f97316',
      fontWeight: '700',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#f97316',
      '&:hover': {
        backgroundColor: '#f97316',
        color: 'white',
      },
      borderRadius: '0 8px 8px 0',
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };

  return (
    <div className={styles['select-container']}>
      <Select
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti}
        closeMenuOnScroll={(e) => {
          if (!e.target) return true;
          const isListBox = e.target.id && e.target.id.includes('listbox');
          const hasMenuClass = typeof e.target.className === 'string' && e.target.className.includes('menu-list');
          if (isListBox || hasMenuClass) {
            return false;
          }
          return true;
        }}
        styles={customStyles}
        required={required}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        onMenuScrollToBottom={onMenuScrollToBottom}
        formatOptionLabel={formatOptionLabel}
      />
    </div>
  );
};

export default CustomSelect;
